/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { moveToLibrary } from 'state/actions/embedsState/embeds_status';
import { invalidateSelectedContent } from 'state/actions/embedsState/embedManagementState/content_status';
import { sendMessage } from '@insticator/insticator-ui'; // iui-state
// component
import StepNavItem from 'material/embeds/steps/stepnav/navitem/navitem';



/* ========== ~~~~~~~~~~ STEP NAV ITEM : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }, { handleSaveEmbed }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    const stepQueue = embedsState.embedManagementState.embedManagementStatus.stepQueue;
    const currentStepIndex = embedsState.embedManagementState.embedManagementStatus.currentStepIndex;
    const changeDetected = embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected ||
        embedsState.embedManagementState.contentStatus.contentChangeDetected
    return {
        stepQueue,
        currentStepIndex,
        clientUUID: sessionStatus.clientUUID,
        selectedContent: !!contentStatus.contents ? contentStatus.contents[contentStatus.selectedContent] : null,
        isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
        isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
        changeDetected,
        handleSaveEmbed
    }
};
// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
        dispatch(updatePageDetails(`dashboard/embeds/management/${location}`));
        dispatch(updateStepDetails(location));
    	dispatch(changePage(`dashboard/embeds/management/${location}`))
    },
    moveToLibrary: clientUUID => dispatch(moveToLibrary()),
    invalidateSelectedContent: () => dispatch(invalidateSelectedContent()),
    sendMessage: message => dispatch(sendMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(StepNavItem);
